import { HttpClient } from '@angular/common/http';
import { AuthService } from '@account-users/auth/auth.service';
import { Inject, Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError /*, switchMap, tap  */ } from 'rxjs/operators';

import { CreateError /*, CreateRenewTokenError */ } from '../../models';
import { BaseCommand } from '../Command';
import { CreateCommandParams, CreateCommandResponse } from './create-command';

@Injectable()
export class CreateCommandService extends BaseCommand<
  CreateCommandParams,
  CreateCommandResponse
> {
  private readonly renewTokenFailedErrorMsg =
    'Could not create the account because of failed authentication. Please reload the page and try again';
  private readonly accountExistsErrorMsg = 'Account name already exist';
  private readonly accountCreateErrorMsg = 'Could not create the account';

  constructor(
    private readonly auth: AuthService,
    private readonly httpClient: HttpClient,
    @Inject('apiBaseUrl') private apiBaseUrl: string,
  ) {
    super();
  }

  public execute(
    createCommand: CreateCommandParams,
  ): Observable<CreateCommandResponse> {
    const createAccount$ = this.httpClient
      .post<CreateCommandResponse>(`${this.apiBaseUrl}accounts`, createCommand)
      .pipe(
        catchError((err) =>
          throwError(
            new CreateError({
              error: err,
              message: this.accountCreateErrorMsg,
              config: { message: this.accountExistsErrorMsg },
            }),
          ),
        ),
      );
    return createAccount$;
    /*const renewTokens$ = this.auth.renewTokens().pipe(
      tap((authResult) => this.auth.setSession(authResult)),
      catchError((err) =>
        throwError(
          new CreateRenewTokenError({
            error: err,
            message: this.renewTokenFailedErrorMsg,
          }),
        ),
      ),
      switchMap(() => createAccount$),
    );
    return renewTokens$;*/
  }
}
